import script from "./Editstat.vue?vue&type=script&setup=true&lang=js"
export * from "./Editstat.vue?vue&type=script&setup=true&lang=js"

import "./Editstat.vue?vue&type=style&index=0&id=5199f8f4&lang=css"

const __exports__ = script;

export default __exports__